import React from "react";
import styled from "styled-components";

// This component takes up 100% of the width of it's parent and takes a percentage of completion as a prop

const StyledProgressBar = styled.div`
  height: 10px;
  width: 100%;
  background: lightgray;
  border-radius: 15px;
  overflow: hidden;
  .completedProgress {
    background: ${props => props.theme.primaryBlue};
    height: 10px;
    width: ${props => props.width}%;
  }
`;

const ProgressBar = ({ percentageComplete }) => {
  return (
    <StyledProgressBar width={percentageComplete * 100 || 0}>
      <div className="completedProgress"></div>
    </StyledProgressBar>
  );
};

export default ProgressBar;
